import React from "react";
import { experience } from "../data";

const formatDateRange = (start, end) => {
  if (start === end) return start;
  return `${start} – ${end}`;
};

export default function Experience() {
  return (
    <section id="experience">
      <div className="container">
        <p className="section-label">experience</p>
        {experience.map((job) => (
          <div key={job.title + job.company} className="exp-row">
            <div className="item-date">{formatDateRange(job.startDate, job.endDate)}</div>
            <div>
              <div className="exp-title">{job.title}</div>
              <div className="exp-company">{job.company}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
